import * as React from 'react';
import GridDayComponent from './calendar-grid-day';
import { IAAPDEvent } from '../classes/event';
import { CalendarAppState } from '../classes/redux-states';
import { connect, Dispatch } from 'react-redux';
import { getEvents } from '../redux/actions/calendar-api';

interface StateToProps {
    eventsByDay: any[];
    state: CalendarAppState;
}

interface DispatchToProps {
    getEvents: () => any;
}

type EventGridProps = StateToProps & DispatchToProps;

export class CalendarGridViewComponent extends React.Component<EventGridProps, null> {
    constructor(props: EventGridProps) {
        super(props);

        this.props.getEvents();
    }

    private get _preFillDates(): Array<any> {
        let firstWeekday = this.props.state.calendarApiModel.selectedDate.clone().startOf('month').format('d');
        let filler = [];
        for (let i = 0; i < parseInt(firstWeekday); i++) {
            filler.push(
                <li className="calendar-grid-day no-events" aria-hidden="true">
                </li>
            );
        }
        return filler;
    }

    private get _postFillDates(): Array<any> {
        let lastWeekday = this.props.state.calendarApiModel.selectedDate.clone().endOf('month').format('d');
        let filler = [];
        for (let i = 6; i > parseInt(lastWeekday); i--) {
            filler.push(
                <li key={i} className="calendar-grid-day no-events" aria-hidden="true">
                </li>
            );
        }
        return filler;
    }

    private get _weekdays(): Array<any> {
        return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map(day => {
            return <li key={day} className="calendar-grid-weekday"><div className="calendar-grid-weekday-inner"><p>{day}</p></div></li>;
        });
    }

    render() {
        return (
            <div className="calendar-container-results">
                <div className="calendar-container-grid">
                    <ul className="calendar-grid-weekdays">
                        {this._weekdays}
                    </ul>
                    <ul className="calendar-grid">
                        {this._preFillDates}
                        {
                            this.props.eventsByDay.map((day, index) => <GridDayComponent key={index} dayOfMonth={this.props.eventsByDay.indexOf(day)} events={day} />)
                        }
                        {this._postFillDates}

                    </ul>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state: CalendarAppState) {
    return {
        eventsByDay: state.calendarApiModel.eventList || [],
        state: state
    }
}

function mapDispatchToProps(dispatch: Dispatch<CalendarAppState>): DispatchToProps {
    return {
        getEvents: () => dispatch(getEvents(false))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarGridViewComponent);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/components/calendar-grid-view.tsx